import AuthoringExperiments from 'bundles/epic/clients/Authoring';
import ContentOptimizationExperiments from 'bundles/epic/clients/ContentOptimization';
import { PLATFORM_ONLY_ITEM_TYPES } from 'bundles/item-authoring/shared/platformOnlyItemTypes';
import type { ItemType } from 'bundles/item/types/ItemType';

/**
 * Function to gate item type migrations onto the item platform / item authoring framework
 */
export const isItemAuthoringFrameworkEnabledForType = (itemType: ItemType): boolean => {
  if (!itemType) {
    return false;
  }

  // 1. [SETUP] set up and add your own item-type-specific feature flag check here while in development (ie requires user/cookie targeting)
  // example epic where we gate by item type: https://tools.coursera.org/epic/experiment/HJG-kI6uEeyAw9c5depHlw
  // when use something like AuthoringExperiments.get('yourEpicName').includes?.(itemType)

  // 2. [CLEANUP] once your item type migration is completed, please clean up your feature flag check and
  // add your item to the static list referenced below.
  if (PLATFORM_ONLY_ITEM_TYPES.includes(itemType)) {
    return true;
  }
  return false;
};

// https://tools.coursera.org/epic/experiment/CH1RJ_xEEe666w76OVbGYQ
export const isPluginUpdatedUiEnabled = () => {
  return AuthoringExperiments.get('enablePluginUpdatedUi');
};

// https://tools.coursera.org/epic/experiment/iG7-ZVamEe-USQr_6ZvHVQ
export const isCourseOutlineSummaryExportsEnabled = () => {
  return AuthoringExperiments.get('enableCourseOutlineSummaryExports');
};

// https://tools.coursera.org/epic/experiment/z3n_v4aWEe-yzhJWa8b7XQ
export const isCoachForAuthorsEnabled = () => {
  return AuthoringExperiments.get('enableCoachForAuthors');
};

// https://tools.coursera.org/epic/experiment/Bj6atwZ9EfC1iRKne8QPDw
export const isCourseBuilderNonEnglishSupportEnabled = (partnerId?: number) => {
  return AuthoringExperiments.get('enableCourseBuilderNonEnglishSupport');
};

// https://tools.coursera.org/epic/experiment/s9lI3W48EfC3IA6hNZeg9Q
export const isCoachForSmartIngestionEnabled = () => {
  return AuthoringExperiments.get('enableCoachForSmartIngestion');
};

export const isGradedPluginEnabled = () => {
  return AuthoringExperiments.get('enableGradedPlugin');
};

// https://tools.coursera.org/epic/experiment/L0AFp7kSEfCgRA4nU0VIYQ
export const isCbVerifiedSkillsP1EnabledByPartnerId = (partnerId?: number) => {
  if (!partnerId && partnerId !== 0) {
    return false;
  }
  return AuthoringExperiments.get('enableCbVerifiedSkillsP1ByPartnerId', { partner_id: partnerId.toString() });
};

// https://tools.coursera.org/epic/experiment/135bswhZEfGgRA4nU0VIYQ
export const isAIGeneratedItemsEnabled = () => {
  return ContentOptimizationExperiments.get('enableAIGeneratedItems');
};

// https://tools.coursera.org/epic/experiment/RCV7AQXmEfGAfhJYNo68EQ
export const isAudioDescriptionAuthoringEnabled = () => {
  return AuthoringExperiments.get('enableAdVideoAuthoring');
};

// https://tools.coursera.org/epic/experiment/eP-7mxQvEfG-lAr_4rnFJw
export const isGeneralVideoPlayerOnLectureItemAuthoringEnabled = () => {
  return AuthoringExperiments.get('enableGeneralVideoPlayerOnLectureItemAuthoring');
};

/**
 * https://tools.coursera.org/epic/experiment/6po_dSI-EfGgRA4nU0VIYQ
 * Using the same epic for FE and BE
 */
export const isCbV3ContextUploadEnabled = () => {
  return AuthoringExperiments.get('useAuthoringFromScratchV2');
};
